<template>
	<div class="cbox-l1">
		<b-navbar
			:toggleable="false"
			type="light"
			variant="light"
			class="d-none d-md-block">
			<div class="container">
				<!-- <b-navbar-toggle target="nav-collapse"></b-navbar-toggle> -->
				<b-navbar-nav v-if="userInfo.name">
					<b-nav-item to="/" >Home</b-nav-item>
				</b-navbar-nav>

				<!-- Right aligned nav items -->
				<b-navbar-nav class="ml-auto">
					<b-nav-text
						v-if="userInfo.name">
						<span class="text-capitalize">{{ userInfo.action }}</span> 
						<span> - </span> 
						<span class="mx-1">{{ userInfo.name }}</span>
						<span>{{ userInfo.phone | phone }}</span>
					</b-nav-text>
					<b-nav-item
						href="#" 
						@click.prevent="openModal('Log in')">
						<span v-if="!userInfo.name">Login</span>
						<b-icon v-else icon="pencil"></b-icon>
					</b-nav-item>
				</b-navbar-nav>
			</div>
		</b-navbar>
		<b-navbar
			:toggleable="false"
			type="light"
			variant="light"
			class="d-md-none">
			<div class="container">
				<b-navbar-nav>
					<b-nav-item to="/" v-if="userInfo.name">Home</b-nav-item>
				</b-navbar-nav>

				<b-navbar-nav>
					<b-nav-text
						v-if="userInfo.name">
						<span class="text-capitalize">{{ userInfo.action }}</span> 
					</b-nav-text>
					<b-nav-item
						href="#" 
						@click.prevent="openModal('Log in')">
						<span v-if="!userInfo.name">Login</span>
						<b-icon v-else icon="pencil"></b-icon>
					</b-nav-item>
				</b-navbar-nav>

			</div>
		</b-navbar>

		<!-- The auth modal -->
		<b-modal 
			id="auth-modal" 
			centered 
			:hide-header="true"
			:hide-footer="true"
			no-close-on-backdrop
			no-close-on-esc
			hide-header-close>
			<user-info
				v-if="initFlag"
				:user="userInfo"
				@close="closeModal">
			</user-info>
		</b-modal>
	</div>
</template>

<script>
import {mapState} from 'vuex'
import UserInfo from '../UserInfo'
export default {
	computed: { 
		...mapState({
			userInfo: 'userInfo'
		}) 
	},
	props: {
    	isRouteChange: {type: Boolean}
    },
	components: {
		UserInfo
	},
	data() {
		return {
			initFlag: false,
		}
	},
	mounted() {		
		this.initFlag = true
		this.checkUserInfo()
	},
	watch: {
		isRouteChange : {
			deep: true,
            handler() {
               this.checkUserInfo()
            }
		},
		userInfo : {
			deep: true,
            handler() {
               this.checkUserInfo()
            }
		}
	},
	methods: {
		checkUserInfo() {
			if(this.userInfo.name === null && this.$route.matched.some(record => record.meta.requiresAuth)){
				this.openModal();
			}else{
				this.closeModal();// close is compulsary for bypass Page.
			}
		},
		openModal() {
			this.$bvModal.show('auth-modal');
		},

		closeModal() {
			this.$bvModal.hide('auth-modal');
		},

		authenticate() {
			// authenticate user against some API
			console.log('submit log in')
		},

		send_instructions() {
			console.log('instruction was sent');
		}
	}
};
</script>

<style lang="scss" >
	@media (min-width: 576px) {
		#auth-modal, #c-auth-modal {
			.modal-dialog {
				max-width: 400px;
			}
		}
	}
</style>